export function downloadFile(path, name) {
  if (!path) {
    return;
  }

  var link = document.createElement('a');
  link.download = name;
  link.href = path;
  link.click();
}